import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfMdTransitionSubscriberContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

// https://api.akaun.cloud/core2/tnt/dm/wf/md/process-transition-notification-subscriber/backoffice-ep

@Injectable({ providedIn: "root" })
export class WfMdTransitionSubscriberService extends BaseApiTemplateService<WfMdTransitionSubscriberContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/process-transition-notification-subscriber/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/process-transition-notification-subscriber/backoffice-ep";
    this.httpClient = http;
  }
}
